import { render } from "./OrderConfirm.vue?vue&type=template&id=63f37110&scoped=true"
import script from "../js/order-confirm.js?vue&type=script&lang=js&external"
export * from "../js/order-confirm.js?vue&type=script&lang=js&external"

import "./OrderConfirm.vue?vue&type=style&index=0&id=63f37110&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f37110"]])

export default __exports__